// extracted by mini-css-extract-plugin
module.exports = {"unusedCarouselSpace":"92px","AdsCarousel":"_3MqEoR","AdBox":"_21W0V2","AdPackshot":"_1BQJnz","AdDescription":"_2LWvtR","fadeInFrames":"_3nIQPE"};